import { Component, Input, OnInit, inject } from "@angular/core";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { JobStore } from "@app/services/store/job-store";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Job } from "@app/models/rest/job";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import {
  CollectionFilterConfig,
  FieldFilterPickerConfig,
  Store as BryntumStore
} from "@bryntum/core-thin";
import {
  ColumnConfig,
  DateColumnConfig,
  FilterConfig,
  NumberColumnConfig
} from "@bryntum/grid-thin";
import { ZoneStore } from "@app/services/store/zone-store";
import { PriorityStore } from "@app/services/store/priority-store";
import { GridComponent } from "../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";

// TODO: Move to shared module

@Component({
  selector: "app-job-table-viewer",
  templateUrl: "./job-table-viewer.component.html",
  styleUrls: ["./job-table-viewer.component.scss"],
  imports: [GridComponent, MatPaginator]
})
export class JobTableViewerComponent
  extends BaseDataTablePageDirective<Job>
  implements OnInit
{
  protected jobStore: JobStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;
  protected zoneStore = inject(ZoneStore);
  protected priorityStore = inject(PriorityStore);

  @Input()
  public columns: (ColumnConfig | DateColumnConfig | NumberColumnConfig)[] = [
    {
      field: "externalJobReference",
      text: "Job",
      flex: 1,
      editor: false
      // filterType: "text"
    },
    {
      field: "externalPropertyReference",
      text: "Property",
      flex: 1,
      editor: false
      // filterType: "text"
    },
    {
      field: "externalProjectReference",
      text: "Project",
      flex: 1,
      editor: false
      // filterType: "text"
    },
    {
      field: "externalCaseReference",
      text: "Case",
      flex: 1,
      editor: false
      // filterType: "text"
    },
    {
      field: "planningWindowEnd",
      text: "Planning Window End",
      flex: 1,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: false
    },
    {
      field: "status",
      text: "Status",
      flex: 1,
      sortable: false
    },
    {
      field: "location.latitude",
      text: "Latitude",
      flex: 1,
      type: "number",
      editor: false
    },
    {
      field: "location.longitude",
      text: "Longitude",
      flex: 1,
      type: "number",
      editor: false
    },
    {
      field: "postCode",
      text: "Post Code",
      flex: 1,
      editor: false
    },
    {
      field: "zone.name",
      text: "Zone",
      flex: 1,
      editor: false,
      sortable: true,
      groupable: false
    },
    {
      field: "priority.description",
      text: "Priority",
      flex: 1,
      editor: false,
      sortable: true,
      groupable: false
    },
    {
      type: "jobJump",
      exportable: false,
      text: "Job Link",
      width: "90px"
    } as unknown as ColumnConfig
  ];
  fakeJobStore = new BryntumStore({
    fields: ["id", "name", "status"],
    data: [
      {
        id: 1,
        externalJobReference: "Job 1",
        externalProjectReference: "sample",
        status: "DRAFT",
        postCode: "BN1 1AA"
      },
      { id: 2, name: "Job 2", status: "RELEASED" },
      { id: 3, name: "Job 3", status: "CANCELLED" },
      { id: 4, name: "Job 4", status: "COMPLETED" }
    ]
  });

  // statusFilterCreated: boolean = false;
  filterConfig: FilterConfig = {
    pickerConfig: {
      showAddFilterButton: false,
      dateFormat: "DD/MM/YYYY",

      canDeleteFilter: (filter) => {
        return filter.property !== "status";
      },
      getFieldFilterPickerConfig: (
        collectionFilterConfig: CollectionFilterConfig
      ): Partial<FieldFilterPickerConfig> => {
        switch (collectionFilterConfig.property) {
          case "planningWindowEnd":
            return {
              dateFormat: "DD/MM/YYYY",
              getValueFieldConfig: (filter, fieldConfig) => {
                console.log(filter, fieldConfig);
                fieldConfig.type = "date";
                fieldConfig.format = "DD/MM/YYYY";
                return fieldConfig;
              },
              operators: this.dateOperators
            };
          case "postCode":
          case "externalPropertyReference":
          case "externalProjectReference":
          case "externalCaseReference":
          case "externalJobReference":
            let stringFieldResult: any = {
              store: this.fakeJobStore,
              operators: this.stringOperators
            };
            if (
              this.gridStore.filters.findItem(
                "property",
                collectionFilterConfig.property
              ) === null
            ) {
              stringFieldResult.filter = {
                id: `${collectionFilterConfig.property}-${collectionFilterConfig.operator}`,
                property: collectionFilterConfig.property,
                operator:
                  collectionFilterConfig.operator === "includes"
                    ? "*"
                    : collectionFilterConfig.operator,
                value: collectionFilterConfig.value
              };
            }
            return stringFieldResult;
          case "priority.description":
          case "zone.name":
          case "status":
            const fixedFieldResult: any = {
              operatorLocked: true,
              propertyLocked: true,
              store: this.fakeJobStore,
              operators: this.fixedSetOperators,
              getValueFieldConfig: (filter, fieldConfig) => {
                fieldConfig.createOnUnmatched = false;
                return fieldConfig;
              }
            };
            if (
              this.gridStore.filters.findItem(
                "property",
                collectionFilterConfig.property
              ) === null
            ) {
              fixedFieldResult.filter = {
                id: `${collectionFilterConfig.property}-isIncludedIn`,
                property: collectionFilterConfig.property,
                operator: "isIncludedIn",
                value: collectionFilterConfig.value,
                disabled: collectionFilterConfig.disabled
              };
            }
            return fixedFieldResult;
        }
        return {};
      }
    }
  };
  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const jobStore = inject(JobStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      jobStore,
      store,
      dialog,
      "Job",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.jobStore = jobStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  ngOnInit() {
    super.ngOnInit();
    this.zoneStore.loadAll().then((value) => {
      value.resources.forEach((zone, index) => {
        this.fakeJobStore.add({
          id: index + 1000,
          name: zone.name,
          zone: zone
        });
      });
    });
    this.priorityStore.loadAll().then((value) => {
      value.resources.forEach((priority, index) => {
        this.fakeJobStore.add({
          id: index + 2000,
          name: priority.description,
          priority: priority
        });
      });
    });
  }

  openJob(job: Job) {
    this.router.navigate(["/jobs", "detail", job.id]).then();
  }

  onEvent($event: any) {
    if ($event.type === "jobjump") {
      this.openJob($event.record);
      return;
    }
    super.onEvent($event);
  }

  gridTotalChange($event: any) {
    console.log("total change");
    console.log($event);
  }
}
